export function hrValuesAgree(source, graph) {
  const valid = (values) =>
    Number.isInteger(values?.min) &&
    Number.isInteger(values?.max) &&
    values.min >= 0 &&
    values.min <= values.max;
  if (!valid(graph)) return false;
  return [source?.heartRateBox, source?.summary].every(
    (section) =>
      section?.recognized &&
      valid(section) &&
      section.min === graph.min &&
      section.max === graph.max
  );
}
